import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import {
  loadArchiveSettings,
  LoadArchiveSettingsResponse,
} from '~src/services/api/archiveSettings';
import { useProjectId } from '../useProjectId';

export const useArchiveSettings = (
  queryConfig: QueryConfig<LoadArchiveSettingsResponse, AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();
  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const archiveSettingsQuery = useQuery<
    LoadArchiveSettingsResponse,
    AxiosError
  >(
    [
      'archiveSettingsList',
      {
        projectId: String(projectId),
      },
    ],
    loadArchiveSettings,
    {
      staleTime: 60 * 1000, // 1min
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return archiveSettingsQuery;
};
